import { render, staticRenderFns } from "./BuildingDisplay.vue?vue&type=template&id=5e02e124&scoped=true&"
import script from "./BuildingDisplay.vue?vue&type=script&lang=js&"
export * from "./BuildingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02e124",
  null
  
)

export default component.exports